







































































































































































































































































































































import Component from 'vue-class-component';
import ShopModuleComponent, { ShopModuleValidationError } from '../module';
import CardHeading from '@/pages/shop/components/CardHeading.vue';
import EventGroupItem from '@/pages/shop/components/EventGroupItem.vue';
import {
    AddProductEvent,
    Branding,
    Price,
    PricingMethod,
    ShopProduct,
} from '@openticket/lib-shop';
import { TranslateResult } from '@openticket/vue-localization';
import { getGlobalProduct } from './utils';
import {
    CLASS_NAME,
    CheckCoverageResult,
    CoverGeniusClient,
    CoverGeniusEventTrackData,
    CoverGeniusRequestEventTrackData,
    CoverGeniusResponseEventTrackData,
    QuoteModel,
} from './coverGeniusClient';
import VueError from '@/error';

let coverGeniusChoiceMade = false;

// DD-COVER-GENIUS-2715 - No cover genius protection is offered for one page shops
// DD-COVER-GENIUS-2716 - Shops with Widget might add tickets that then are not taken into account when accepting
// the place order (not be fully added to the total). This might lead to weird unintended behaviour currently
// outside the scope

@Component({
    components: {
        EventGroupItem,
        CardHeading,
    },
})
export default class CoverGeniusProduct extends ShopModuleComponent {
    checked: null | boolean = null;
    localizationListener!: number;
    themeListener: number | null = null;
    isDark = false;
    loading = false;
    internalPrice = 0;
    partnerSlug: string | null = null;
    protectedValue: number | null = null;
    firstQuotePolicy: QuoteModel['policy'] | null = null;
    pdsUrl: string | null = null;
    trackingData: CoverGeniusEventTrackData = {};

    get reasons(): TranslateResult {
        return this.$t('shop.components.cover_genius.covered.reasons');
    }

    async created(): Promise<void> {
        if (!this.product) {
            return;
        }

        // Reset when CoverGeniusClient no longer has an itemid
        if (CoverGeniusClient.itemId == null) {
            coverGeniusChoiceMade = false;
        }

        this.themeListener = this.$style.addThemeListener(() => {
            this.setTheme();
        });
        this.setTheme();

        // Treat the slug attribute in the branding shop data as unknown
        // Only set the partner slug when we are sure this slug is a string
        const whitelabelBranding: Branding & { slug: unknown | null } = this
            .$shop.data.branding as Branding & { slug: unknown | null };
        if (typeof whitelabelBranding.slug === 'string') {
            this.partnerSlug = whitelabelBranding.slug;
        }

        CoverGeniusClient.listener = async () => {
            await this.updateChecked();
        };

        const info: AddProductEvent = this.$shop.cart.getProductInfo(
            this.product!.guid
        );

        const result = await CoverGeniusClient.checkCoverage(
            this.$shop,
            this.$localization.locale.language,
            this.partnerSlug
        );

        if (info.count >= 1 && !result.coverable) {
            // DD-COVER-GENIUS-2713 - When a quote has been given, but after some changes to the cart
            // are made that make the order not coverable, then the original quote
            // (cover genius product) is automatically removed from the cart
            await this.onValueChanged(false);
        } else {
            this.applyCheckCoverageResult(result);
        }

        this.localizationListener = this.$localization.on(
            'locale-change',
            async () => {
                const localeResult = await CoverGeniusClient.checkCoverage(
                    this.$shop,
                    this.$localization.locale.language,
                    this.partnerSlug
                );
                this.applyCheckCoverageResult(localeResult);
            }
        );

        this.updateChecked();
    }

    private applyCheckCoverageResult(result: CheckCoverageResult): void {
        CoverGeniusClient.lastResult = result;

        if (result.requestBody) {
            this.track(
                ['quote', 'requested'],
                result.requestBody as CoverGeniusRequestEventTrackData
            );
        }

        if (
            result &&
            result.coverable &&
            result.quotes &&
            result.quotes.length > 0
        ) {
            // DD-CoverGenius-2717 Pick the first policy for the terms/wording link
            this.firstQuotePolicy = result.quotes[0].policy;
            this.pdsUrl = result.pdsUrl;
            this.protectedValue = result.protectedValue;
            this.trackingData.quote_id = result.quoteId || undefined;
            this.setTechDataQuoteId(result.quoteId);

            if (this.product) {
                Price.computeProductPricing(
                    this.product.pricing,
                    result.protectedValue
                );
            }

            if (this.product?.item.pricing_method === PricingMethod.Container) {
                this.internalPrice = this.product.pricing.total_price;
            } else {
                this.internalPrice = result.price;
                CoverGeniusClient.applyPrice(this.$shop.cart);
            }

            this.track(['quote', 'received'], this.trackingData);
        } else {
            this.firstQuotePolicy = null;
            this.internalPrice = 0;
            this.pdsUrl = null;
            delete this.trackingData.quote_id;
            this.setTechDataQuoteId(null);
            if (result.requestBody) {
                this.track(['quote', 'rejected']);
            }
        }
    }

    public validate(): ShopModuleValidationError | null {
        if (
            coverGeniusChoiceMade ||
            !this.orderIsPaid ||
            !this.product ||
            !this.firstQuotePolicy
        ) {
            return null;
        }

        return {
            message:
                'A choice should be made whether to make the order refundable.',
            slug: 'shop.components.cover_genius.should_make_choice',
        };
    }

    beforeDestroy(): void {
        if (this.localizationListener) {
            this.$localization.off(this.localizationListener);
        }
        if (CoverGeniusClient.listener) {
            CoverGeniusClient.listener = () => {
                /* No-op */
            };
        }
    }

    destroyed(): void {
        if (this.themeListener !== null) {
            this.$style.removeThemeListener(this.themeListener);
        }
    }

    setTheme(): void {
        switch (this.$style.getAppliedTheme()) {
            case 'dark':
                this.isDark = true;
                break;
            case 'light':
            default:
                this.isDark = false;
                break;
        }
    }

    get orderIsPaid(): boolean {
        return this.$shop.cart.checkout_details.total_price > 0;
    }

    get product(): ShopProduct | undefined {
        return getGlobalProduct(
            this.$shop.data,
            CLASS_NAME,
            this.$route.params.eventId
        );
    }

    get coverGeniusPeopleCount(): number {
        // This formula is close enough to not be a lie, yet does not give away exact counts
        // https://app.clickup.com/t/86by5urvg
        const socialProofCounter =
            8159 + Math.floor((Date.now() / 1000 - 1707433206) / 86400);
        this.trackingData.social_proof_counter = socialProofCounter;
        return socialProofCounter;
    }

    get price(): string {
        if (this.internalPrice === 0) {
            delete this.trackingData.displayed_price;
            return '';
        }

        this.trackingData.displayed_price = this.internalPrice;
        return `+ ${this.$l.currency(
            this.internalPrice,
            this.$shop.data.currency as string
        )}`;
    }

    get totalProtectedValue(): number {
        return this.protectedValue || 0;
    }

    async updateChecked(): Promise<void> {
        const info: AddProductEvent = this.$shop.cart.getProductInfo(
            this.product!.guid
        );

        if (info.count > 0) {
            const fingerprint = CoverGeniusClient.computeCartFingerprint(
                this.$shop.cart
            );
            if (fingerprint !== CoverGeniusClient.lastFingerprint) {
                // Ticket setup changed, clear CoverGenius and let user re-select
                CoverGeniusClient.reset();
                coverGeniusChoiceMade = false;
                this.checked = null;
                await this.$shop.cart.removeProduct(this.product!.guid);
            } else {
                this.checked = true;
            }
        } else if (coverGeniusChoiceMade) {
            this.checked = false;
        } else {
            this.checked = null;
        }
    }

    async selectCoverGenius(): Promise<void> {
        if (this.checked) {
            return;
        }

        return this.onValueChanged(true);
    }

    async deselectCoverGenius(): Promise<void> {
        coverGeniusChoiceMade = true;

        if (!this.checked) {
            this.checked = false;

            this.track(['product', 'deselected'], this.trackingData); // covergenius-product-deselected event source (rudderstack)

            return;
        }

        return this.onValueChanged(false);
    }

    async onValueChanged(value: boolean): Promise<void> {
        this.loading = true;

        try {
            if (value) {
                const addProductEvent = await this.$shop.cart.addProduct(
                    this.product!.guid,
                    {
                        quoteId:
                            CoverGeniusClient.lastResult?.quoteId ?? undefined,
                    }
                );

                if (
                    this.product?.item.pricing_method ===
                    PricingMethod.Container
                ) {
                    CoverGeniusClient.lastFingerprint = CoverGeniusClient.computeCartFingerprint(
                        this.$shop.cart
                    );
                } else {
                    CoverGeniusClient.itemId = addProductEvent.items[0].id;
                    CoverGeniusClient.applyPrice(this.$shop.cart);
                }

                this.track(['product', 'selected'], this.trackingData); // covergenius-product-selected event source (rudderstack)
            } else {
                CoverGeniusClient.reset();
                await this.$shop.cart.removeProduct(this.product!.guid);

                this.track(['product', 'deselected'], this.trackingData); // covergenius-product-deselected event source (rudderstack)
            }
        } finally {
            coverGeniusChoiceMade = true;
            this.loading = false;
        }
    }

    track(
        path: string[],
        data?:
            | CoverGeniusEventTrackData
            | CoverGeniusResponseEventTrackData
            | CoverGeniusRequestEventTrackData
    ): void {
        try {
            this.$shop.events.emit(['covergenius', ...path], data);
        } catch (e) {
            // Should not block
            this.$logger.log(
                new VueError('Emit CoverGenius tracking event failed', e)
            );
        }
    }

    setTechDataQuoteId(quoteId: string | null): void {
        this.$shop.cart.setTechData({
            quoteId: quoteId,
        });
    }
}
